import { useMemo } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'

import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Lozenge from '~/components/atoms/Lozenge/Lozenge'
import LozengeList from '~/components/blocks/LozengeList/LozengeList'
import { ComponentTheme } from '~/components/themes'

import styles from './PressFilter.module.css'

export interface PressFilterProps {
  categories?: { name: string; slug: string }[]
  testID?: string
  theme?: ComponentTheme
}

export default function PressFilter({
  categories,
  theme = ComponentTheme.primary,
  testID,
}: PressFilterProps) {
  const { query } = useRouter()
  const category = useMemo(() => {
    return query.category
  }, [query])

  return (
    <div className={styles.base} data-testid={testID}>
      <Fixture verticalPadding={false} theme={theme}>
        <Container>
          {categories && categories.length > 0 && (
            <div className={styles.subMenuContainer}>
              <LozengeList className={styles.subMenu}>
                {categories &&
                  categories.map((item, index) => (
                    <Link
                      href={
                        category === item.slug
                          ? `/press/all-articles`
                          : `/press/all-articles/?category=${item.slug}`
                      }
                      key={`category-associated-item-${index}`}
                      shallow={true}
                    >
                      <Lozenge
                        count={category === item.slug ? 'x' : ''}
                        title={item.name}
                      />
                    </Link>
                  ))}
              </LozengeList>
            </div>
          )}
        </Container>
      </Fixture>
    </div>
  )
}
